import { Application } from "@hotwired/stimulus"

// MS50 #2611: gate noisy [STIMULUS] diagnostic logging + Stimulus debug mode to
// development only. The <meta name="app-environment"> tag is rendered by the
// layout <head>.
const isDev = document.querySelector('meta[name="app-environment"]')?.content === "development";

if (isDev) console.log('[STIMULUS] Starting Stimulus application...')

const application = Application.start()

// Configure Stimulus development experience (debug mode in development only)
application.debug = isDev  // Enable debug mode to see controller registration
window.Stimulus   = application

if (isDev) {
  console.log('[STIMULUS] Stimulus application started, debug mode enabled')
  console.log('[STIMULUS] window.Stimulus =', window.Stimulus)
}

export { application }
